module.exports = __webpack_public_path__ + "static/img/アセット 18@2x.2c7f639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 18@2x.png
// module id = VClL
// module chunks = 1